import * as React from "react";
import { useReducer, useMemo, useContext } from "react";
const ColumnsTogglerContext = React.createContext(null);
const toLabel = (text) => text.replace(/^(\w)|_(\w)/g, (char) => char.toUpperCase()).replaceAll("_", " ");
const getColumns = (cacheId) => {
  var _a;
  return JSON.parse((_a = localStorage.getItem(cacheId)) != null ? _a : "{}");
};
const cacheColumns = (cacheId, columns) => localStorage.setItem(cacheId, JSON.stringify(columns));
const initColumns = (cacheId, initState) => {
  const auxInitState = { ...initState };
  const cachedCols = getColumns(cacheId);
  Object.keys(auxInitState).forEach((col) => {
    var _a, _b;
    auxInitState[col].visible = (_b = (_a = cachedCols[col]) == null ? void 0 : _a.visible) != null ? _b : initState[col].visible;
  });
  const newState = Object.keys(auxInitState).reduce((acc, columnKey) => {
    acc[columnKey] = {
      label: toLabel(columnKey),
      visible: auxInitState[columnKey].visible,
      group: auxInitState[columnKey].group
    };
    return acc;
  }, {});
  cacheColumns(cacheId, { ...cachedCols, ...newState });
  return { ...cachedCols, ...newState };
};
const reducer = (state, action) => {
  const { type } = action;
  if (type === "init") {
    const { cacheId, initState } = action.payload;
    return initColumns(cacheId, initState);
  }
  if (type === "toggle") {
    const { cacheId, column } = action.payload;
    const newState = { ...state };
    newState[column].visible = !newState[column].visible;
    cacheColumns(cacheId, newState);
    return newState;
  }
  if (type === "reset") {
    const { cacheId, colsToRemove } = action.payload;
    const newState = Object.keys(state).reduce((acc, columnKey) => {
      if (colsToRemove.includes(columnKey)) return acc;
      acc[columnKey] = state[columnKey];
      return acc;
    }, {});
    cacheColumns(cacheId, newState);
    return newState;
  }
  return state;
};
export const ColumnTogglerProvider = ({ cacheId, children }) => {
  const [columns, columnsDispatch] = useReducer(reducer, getColumns(cacheId));
  const contextValue = useMemo(
    () => ({
      cacheId,
      columns,
      columnsDispatch,
      visibleColumnsCount: Object.values(columns).filter((col) => col.visible).length
    }),
    [cacheId, columns, columnsDispatch]
  );
  return /* @__PURE__ */ React.createElement(ColumnsTogglerContext.Provider, { value: contextValue }, children);
};
export const useColumnTogglerContext = () => useContext(ColumnsTogglerContext);
